//@flow
import React, { Component } from 'react'
import { connect } from 'react-redux'
import styled, {css} from 'styled-components';
import { rgba } from 'polished';
import { find, filter, uniqBy } from 'lodash';
import { Link } from 'react-router-dom'
import moment from 'moment'

import { fetchResources, getResources } from './redux';
import { fetchPage, getPages } from '../Page/redux';
import Fade from 'react-reveal/Fade';
import { LetterLinks, Select } from '../../components'

import { paleGreen } from '../../styles/colors';
import { hoverState, body, padding, container, bgImage } from '../../styles/global';
import { media } from '../../styles/utils';
import MetaTags from '../../components/MetaTags/MetaTags';

type Props = {}

type State = {}

class Resources extends Component<Props, State> {

    state = {
        selectedType: null
    }

    componentWillMount() {
        const {fetchResources,fetchPage} = this.props;
        fetchResources();    
        fetchPage('resources');
    }

    onSelectChange = (value, type) => {
        this.setState({
            [`selected${type}`]: value.value == 'all' ? null : value.value
        })
    }

    renderSupporterFilters = () => {
        const {resources} = this.props;

        if (resources.data) {

            let types = []

            resources.data.forEach((resource, index) => {
                types.push({
                    slug: resource.type,
                    name: resource.type
                });   
            })

            types = uniqBy(types, 'slug');

            const typeOptions = types.map((item, index) => {
                return (
                    { value : item.slug, label: item.name }
                )
            })
            
            typeOptions.unshift({ value : 'all', label: 'All' })

            return (
                <Filters>
                    <FilterBy>Filter By</FilterBy>
                    <Select
                        options={typeOptions}
                        placeholder={'Type'}
                        onSelectChange={(value) => this.onSelectChange(value, 'Type')}
                    />
                </Filters>
            )
        }
    }

    renderResources = () => {
        const {resources} = this.props;
        const {selectedType} = this.state;

        if (resources.data) {

            let filteredResources = resources.data;

            if (selectedType) {
                filteredResources = filter(filteredResources, { type: selectedType });
            }

            const resourceItems = filteredResources.map((resource, index) => {

                return (
                    <Resource
                        href={resource.url}
                        target={'_blank'}
                        key={index}
                    >
                        <Image
                            image={resource.image}
                        />

                        <Info>
                            <Title>{resource.title}</Title>
                            <Type>{resource.type.toUpperCase()}</Type>
                        </Info>
                    </Resource>
                )
            })

            return (
                <GridContainer>
                    {this.renderSupporterFilters()}
                    <Grid>
                        {resourceItems}
                    </Grid>
                </GridContainer>
            )
        }
    }
    
    render() {
        const {pages} = this.props;
        const pageData = find(pages, (o) => { return o.slug == 'resources' })

        return (
            <Container>
                
                {pageData && (
                    <MetaTags
                        title={'Resources'}
                        description={pageData.introduction}
                    />
                )}

                {pageData && (
                    <Fade
                        // up
                        duration={1000}
                        distance={'50px'}
                    >
                        <div>
                            <Description
                                dangerouslySetInnerHTML={{__html: pageData.introduction}}
                            />
                            <Button
                                href="https://airtable.com/shrA9ojtAbwm4ug1E"
                                target="_blank"
                            >
                                Submit your link
                            </Button>
                        </div>
              
                    </Fade>
                )}
            
                {pageData && (
                    <Fade
                        duration={2000}
                    >
                        <div>
                            <Heading>Further Resources</Heading>
                            {this.renderResources()}
                        </div>
                    </Fade>
                )}

            </Container>
        )
    }
}

const Container = styled.div`
    background: white;
    min-height: 100vh;

    display: flex;
    align-items: center;
    flex-direction: column;

    .react-reveal {
        display: flex;
        align-items: center;
        flex-direction: column;
        width: 100%;
    }
`;

const Description = styled.div`
    ${padding}
    margin-top: 128px;
    margin-bottom: 40px;
    max-width: 740px;
    text-align: center;

    p {
        font-family: TiemposText-Regular;
        font-size: 15px;
        color: #5F5F5F;
        letter-spacing: 0;
        text-align: center;
        line-height: 27px;
    }

    ${media.phone`
        margin-top: 96px;
        margin-bottom: 64px;
    `}
`;

const Heading = styled.div`
    font-family: Platform-Medium;
    font-size: 32px;
    color: #4D4D4D;
    letter-spacing: 0.19px;
    margin-bottom: 32px;
`

const Button = styled.a`
    margin-bottom: 100px;
    display: flex;
    justify-content: center;
    align-items: center;

    background: rgba(0,0,0,0.1);
    box-shadow: 0 2px 1px 0 rgba(0,0,0,0.02);
    border-radius: 8px;

    width: 182px;
    height: 52px;

    font-family: 'Platform-Regular';
    font-size: 14px;
    color: #4D4D4D;
    letter-spacing: 1.28px;
    text-align: center;
    line-height: 9px;    

    transition: all 0.1s ease;

    &:hover {
        color: white;
        background: #DB5537;
        box-shadow: 0 2px 1px 0 rgba(0,0,0,0);
    }

`

const GridContainer = styled.div`
    background: #FCFCFC;
    border-top: 1px solid #F1F1F1;
    width: 100%;
    flex: 1;
    padding-top: 32px;
    padding-bottom: 100px;

    display: flex;
    flex-direction: column;
    align-items: center;
    
    ${media.phone`
        padding-top: 32px;
        padding-bottom: 64px;
    `}
`;

const Grid = styled.div`
    display: flex;
    flex-flow: row wrap;
    width: 100%;
    max-width: 1024px;
    transform: translateX(15px);
    padding-top: 69px;
    min-height: 400px;

    ${media.phone`
        padding-top: 32px;
    `}
`;

const Resource = styled.a`
    display: flex;
    flex-direction: column;
    flex: 0 1 calc(33.3% - 30px);
    height: 238px;

    background: white;
    box-shadow: 0 3px 5px 0 rgba(0,0,0,0.01);
    border: 1px solid #F1F1F1;
    border-radius: 4px;
    overflow: hidden;

    box-sizing: border-box;
    margin-bottom: 30px;
    margin-right: 30px;
    ${hoverState}
    cursor: pointer;

    ${media.laptop`
        flex: 0 1 calc(50% - 30px);
        height: 320px;
    `}

    ${media.phone`
        flex: 0 1 calc(100% - 30px);
        height: 320px;
    `}
`;

const Image = styled.div`
    ${bgImage}
    background-image: url(${props => props.image});
    flex: 1;
    width: 100%;
`;

const Info = styled.div`
    display: flex;
    align-items: center;    
    justify-content: space-between;
    min-height: 64px;
    padding: 0 22px;
`;

const Title = styled.div`
    font-family: 'Platform-Regular';
    font-size: 13px;
    color: #5F5F5F;
    letter-spacing: 1.19px;
    line-height: 19px;
    padding: 15px 10% 15px 0;
`;

const Type = styled.div`
    font-family: 'Platform-Regular';
    font-size: 13px;
    color: #807c7c;
    letter-spacing: 1.19px;
    line-height: 9px;
`;

// Filters

const Filters = styled.div`
    width: 100%;
    max-width: 1024px;
    padding-left: 48px;
    display: flex;
    align-items: center;

    > * {
        margin-right: 40px;
    }

    ${media.phone`
        flex-direction: column;
        align-items: flex-start;

        > * {
            margin-right: 0;
            margin-bottom: 18px;
        }
    `}
`

const FilterBy = styled.div`
    font-family: 'Platform-Regular';
    font-size: 14px;
    color: #5F5F5F;
    letter-spacing: 1.28px;
    line-height: 9px;
    text-transform: uppercase;
    margin-right: 24px;

    ${media.phone`
        margin-bottom: 32px;
    `}
`








const mapDispatchToProps = dispatch => ({
    fetchResources() {
        dispatch(fetchResources())
    },
    fetchPage(slug) {
        dispatch(fetchPage(slug))
    }
})

const mapStateToProps = (state, props) => ({
    resources: getResources(state),
    pages: getPages(state)
})

export default connect(mapStateToProps, mapDispatchToProps)(Resources);



// WEBPACK FOOTER //
// ./client/modules/Resources/Resources.js